import styled from 'styled-components';
export const FlyoutWrapper = styled.div `
  ${({ visible }) => (visible ? 'display: block;' : 'display: none;')}
  position: absolute;
  top: 2.5rem;
  left: 1.5rem;
  min-width: 15rem;
  background-color: ${({ theme }) => theme.colors.white};
  z-index: 22;
`;
export const Wrapper = styled.div `
  button {
    padding-right: 0.25rem;
    padding-left: 0.25rem;
    min-width: alignByContent;
    ${({ alignByContent }) => alignByContent === 'left'
    ? 'transform: translateX(calc(-0.25rem - 1px))'
    : alignByContent === 'right'
        ? 'transform: translateX(calc(0.25rem + 1px))'
        : ''}
  }

  ${FlyoutWrapper} {
    ${({ alignByContent }) => alignByContent === 'left'
    ? 'left: calc(1.25rem - 1px)'
    : alignByContent === 'right'
        ? 'left: calc(1.75rem + 1px)'
        : 'left: 1.5rem'};
  }
`;
